module.exports = __webpack_public_path__ + "img/icon_account.3ac2d324.svg";